module.exports = __webpack_public_path__ + "static/media/project20.f0369344.jpg";